import gql from 'graphql-tag';

const MUTATION_UPDATE_ESIM = gql`
  mutation updateEsim($input: UpdateEsimInput!) {
    updateEsim(input: $input) {
      isSuccess
      message
      esim {
        id
        status
        createdBy {
          id
          firstName
          lastName
        }
        createdAt
        license {
          storage
          licenseType
          isAllowedDual
          id
          name
          productId
        }
        compatibleBrand
        compatibleModel
      }
    }
  }
`;

export default MUTATION_UPDATE_ESIM;
